(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselDots);
  } else {
    initCarouselDots();
  }

  function initCarouselDots() {
    const carousels = document.querySelectorAll('main-product-carousel');
    
    carousels.forEach(carousel => {
      if (carousel.dataset.dotsInitialized) return;
      carousel.dataset.dotsInitialized = 'true';
      
      const carouselId = carousel.dataset.id;
      const dotContainer = document.querySelector(`.carousel-nav-arrow[data-id="${carouselId}"]`);
      
      if (!dotContainer) return;
      
      const dotsWrapper = dotContainer.querySelector('.carousel-nav-dots');
      const dots = dotContainer.querySelectorAll('.carousel-nav-dot');
      const carouselContainer = carousel.querySelector('.carousel--container');
      
      if (!dots || dots.length === 0) return;
      
      let lastActiveDot = -1;
      let isTransitioning = false;
      
      // Update dot classes and position
      const updateDots = () => {
        const slidePosStr = carousel.style.getPropertyValue('--slide-pos');
        if (!slidePosStr) return;
        
        const slidePos = parseFloat(slidePosStr);
        const totalSlides = parseInt(carousel.style.getPropertyValue('--total-slides-mobile')) || dots.length;
        
        // Calculate which slide we're closest to
        const slideProgress = Math.abs(slidePos) / 100;
        const currentSlide = Math.round(slideProgress * totalSlides);
        const clampedSlide = Math.min(Math.max(currentSlide, 0), totalSlides - 1);
        
        // Map slide to dot
        let activeDotIndex;
        if (totalSlides <= dots.length) {
          activeDotIndex = clampedSlide;
        } else {
          activeDotIndex = Math.round((clampedSlide / (totalSlides - 1)) * (dots.length - 1));
        }
        activeDotIndex = Math.min(Math.max(activeDotIndex, 0), dots.length - 1);
        
        // Only update if changed
        if (activeDotIndex === lastActiveDot) return;
        lastActiveDot = activeDotIndex;
        
        // Update dot classes
        dots.forEach((dot, index) => {
          dot.className = 'carousel-nav-dot';
          
          const distance = Math.abs(index - activeDotIndex);
          
          if (index === activeDotIndex) {
            dot.classList.add('carousel-nav-dot--active');
          } else if (distance === 1) {
            dot.classList.add('carousel-nav-dot--smaller');
          } else {
            dot.classList.add('carousel-nav-dot--smallest');
          }
        });
        
        // Move dots wrapper (if more than 5 dots)
        if (dots.length > 5) {
          const dotWidth = 12;
          let offset = 0;
          
          if (activeDotIndex <= 2) {
            offset = 0;
          } else if (activeDotIndex >= dots.length - 3) {
            offset = (5 - dots.length) * dotWidth;
          } else {
            offset = (2 - activeDotIndex) * dotWidth;
          }
          
          dotsWrapper.style.transform = `translateX(${offset}px)`;
        }
      };
      
      // Detect when carousel starts transitioning
      carousel.addEventListener('touchstart', () => {
        isTransitioning = true;
      }, { passive: true });
      
      // Detect when carousel stops transitioning
      carousel.addEventListener('touchend', () => {
        isTransitioning = false;
        // Update immediately when touch ends
        setTimeout(updateDots, 50);
        // And again after transition completes (theme uses ~300ms transitions)
        setTimeout(updateDots, 400);
      }, { passive: true });
      
      // Listen for transitionend on the container
      if (carouselContainer) {
        carouselContainer.addEventListener('transitionend', (e) => {
          if (e.propertyName === 'transform') {
            updateDots();
          }
        });
      }
      
      // Also poll, but less frequently
      setInterval(() => {
        if (!isTransitioning) {
          updateDots();
        }
      }, 300);
      
      // Dot click handlers
      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          const totalSlides = parseInt(carousel.style.getPropertyValue('--total-slides-mobile')) || dots.length;
          
          let targetSlide;
          if (totalSlides <= dots.length) {
            targetSlide = dotIndex;
          } else {
            targetSlide = Math.round((dotIndex / (dots.length - 1)) * (totalSlides - 1));
          }
          
          const targetPos = -(targetSlide / totalSlides) * 100;
          carousel.style.setProperty('--slide-pos', `${targetPos}%`);
          
          // Update immediately
          setTimeout(updateDots, 400);
        });
      });
      
      // Initialize immediately
      updateDots();
    });
  }
})();